import { render, staticRenderFns } from "./taux-chambres.html?vue&type=template&id=1a98e708&scoped=true&external"
import script from "./taux-chambres.js?vue&type=script&lang=js&external"
export * from "./taux-chambres.js?vue&type=script&lang=js&external"
import style0 from "./taux-chambres.scss?vue&type=style&index=0&id=1a98e708&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98e708",
  null
  
)

export default component.exports